import { render, staticRenderFns } from "./ChoiceInput.vue?vue&type=template&id=ee229b14&"
import script from "./ChoiceInput.vue?vue&type=script&lang=js&"
export * from "./ChoiceInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports